import { Modal } from 'antd';

interface AIUpgradeModalProps {
  open: boolean;
  title?: string;
  desc?: string;
  btnTitle?: string;
  onClose?: () => void;
  onUpgrade?: () => void;
}

export default function AIUpgradeModal({
  open,
  title = 'Upgrade Required',
  desc,
  btnTitle = 'Upgrade Now',
  onClose,
  onUpgrade,
}: AIUpgradeModalProps) {
  const handleUpgrade = () => {
    onClose?.();
    onUpgrade?.();
  };

  return (
    <Modal
      width={400}
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnHidden
      centered
      styles={{
        content: {
          padding: 0,
          borderRadius: '12px',
          overflow: 'hidden',
        },
      }}
    >
      <div className="relative p-8">
        {/* 标题 */}
        {title && <h3 className="text-[20px] font-bold text-[#0c0c0c] leading-normal mb-4">{title}</h3>}

        {/* 描述 */}
        {desc && <div className="text-[16px] font-normal text-[#0c0c0c] opacity-60 leading-6 mb-6">{desc}</div>}

        {/* 按钮 */}
        <button
          onClick={handleUpgrade}
          className="w-full h-[42px] rounded-[27px] bg-gradient-to-b from-[#725cff] to-[rgba(141,131,255,0.8)] text-white text-[16px] font-semibold shadow-[0px_4px_12px_0px_rgba(114,92,255,0.2)] hover:opacity-90 transition-opacity"
        >
          {btnTitle}
        </button>
      </div>
    </Modal>
  );
}
